import { Pipe, PipeTransform } from '@angular/core';
import { SharedService } from '../shared-service.service';

@Pipe({ name: 'ShortNumber' })

export class ShortNumberPipe implements PipeTransform {
    constructor(private _shared_service: SharedService){}

    transform(value: number): string {
        let _return = this._shared_service.short_number(value, 1);
        return (_return) ? _return : `0`;
    }
}


// WEBPACK FOOTER //
// ./src/app/shared/pipes/short-number.pipe.ts